import { init_gradient_table } from 'amt_admin/utils';

const main_view = {
    template: require('./view.html'),
    controller: [
        '$scope',
        'jsonrpc',
        'chartFilters',
        function($scope, jsonrpc, chartFilters) {
            function set_table_data(resp) {
                $scope.vm.rows = resp.rows;
                $scope.vm.columns = resp.columns;
                const rows = resp.rows.map(row => _.pick(row, ...resp.columns));
                table.set_rows(rows);
            }
            function update_reactivation_table(model) {
                jsonrpc.callServiceMethod('retention.reactivation_table', model).then(set_table_data);
            }

            const table = init_gradient_table();
            $scope.get_bg_color = table.get_bg_color;
            $scope.vm = {};
            update_reactivation_table(chartFilters.get_chart_filters());
            chartFilters.onChangeChartParams('update_reactivation_table', update_reactivation_table);
        },
    ],
};
const state_config = {
    url: '/reactivation',
    reloadOnSearch: false,
    data: {
        priority: 888,
        title: 'Reactivation',
    },
    views: {
        '': main_view,
    },
};
export default state_config;
